import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { Form, InputOnChangeData } from 'semantic-ui-react';
import Currency from './Currency';

interface CurrencyWidgetState {
  displayValue?: string;
}
export default class CurrencyWidgetOne extends React.Component<WidgetProps, CurrencyWidgetState> {
  state: CurrencyWidgetState = {};
  isOnChange: boolean = false;

  onBlur(): void {
    if (typeof this.props.value === 'number' && !isNaN(this.props.value)) {
      this.setState({
        displayValue: this.props.value.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      });
    }
    this.props.onBlur(this.props.id, this.state.displayValue ?? '');
  }

  onChange(e: React.ChangeEvent<EventTarget>, data: InputOnChangeData): void {
    this.isOnChange = true;
    // Set the value
    const value = new Currency(data.value);

    // Call onChange if the value actually changed
    if (new Currency(this.props.value).value !== value.value) {
      this.props.onChange(value.value);
      this.setState({ displayValue: value.displayValue.match(/\.$/) ? value.displayValue : undefined });
    } else {
      this.setState({ displayValue: value.displayValue });
    }
  }

  render(): React.ReactNode {
    const value = new Currency(this.props.value);
    // this.state.displayValue = this.isOnChange ? this.state.displayValue : value.displayValue; 
    
    if (!this.isOnChange && typeof this.props.value === 'number') {
      this.state.displayValue = this.props.value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (!this.isOnChange) {
      this.state.displayValue = value.displayValue;
    }

    const displayValue = this.state.displayValue ?? value.displayValue;
    this.isOnChange = false;
    const width = 120;
    // const width = !value.value
    //   ? 110
    //   : 50 + value.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).length * 7;

    // If it's a read-only field, output the value pre-fixed with a $ sign
    if (this.props.schema.readOnly) {
      return (
        <Form.Field style={{ width }}>
          <label>{this.props.schema.title ? this.props.schema.title : this.props.id.replace(/^root_/, '')}</label>
          <span>{
            value.value
              ? value.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
              : '$0.00'
          }</span>
        </Form.Field>
      );
    }

    return (
      <Form.Input
        style={{ width }}
        type="string"
        label={this.props.schema.title}
        icon="dollar"
        iconPosition="left"
        value={displayValue}
        error={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void =>
          this.onChange(e, data)
        }
        onBlur={(): void => this.onBlur()}
        onFocus={(): void => this.props.onFocus(this.props.id, displayValue)}
        required={this.props.required}
        placeholder={this.props.uiSchema['ui:options']?.placeholder}
      />
    );
  }
}
